export const WR_OPEN = "WR_OPEN";
export const WR_CLOSE = "WR_CLOSE";

export const WR_SET_JOIN_ROOM_REQUEST = "WR_SET_JOIN_ROOM_REQUEST";
export const WR_SET_JOIN_ROOM_SUCCESS = "WR_SET_JOIN_ROOM_SUCCESS";
export const WR_SET_JOIN_ROOM_FAIL = "WR_SET_JOIN_ROOM_FAIL";
export const WR_SET_JOIN_ROOM_RESET = "WR_SET_JOIN_ROOM_RESET";
